import { render } from "./UiPropColorsSelect.vue?vue&type=template&id=1158921a"
import script from "./UiPropColorsSelect.vue?vue&type=script&lang=js"
export * from "./UiPropColorsSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__